import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

const fieldSx = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#fff',
    borderRadius: '4px'
  }
};

const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const phonePattern = /^[0-9\s+\-().]+$/;

const radioSx = {
  color: '#005eb8',
  '&.Mui-checked': { color: '#005eb8' }
};

const validatePhone = (value) => {
  if (!phonePattern.test(value)) {
    return 'Enter a valid phone number';
  }
  const digits = value.replace(/\D/g, '');
  if (digits.length < 10 || digits.length > 15) {
    return 'Phone number must contain 10 to 15 digits';
  }
  return true;
};

const ContactField = ({ index, type, label, rules }) => {
  const { control } = useFormContext();
  const name = `yearlyContact${type}${index}`;

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      rules={rules}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          label={label}
          required
          fullWidth
          size="small"
          sx={fieldSx}
          error={!!fieldState.error}
          helperText={fieldState.error?.message || ' '}
        />
      )}
    />
  );
};

const YearlyPocSection = () => {
  const { control } = useFormContext();

  return (
    <Accordion
      defaultExpanded
      disableGutters
      sx={{
        mt: 1.5,
        mb: 2,
        border: '1px solid #8bcdf4',
        borderRadius: '4px !important',
        boxShadow: 'none',
        overflow: 'hidden',
        '&:before': { display: 'none' }
      }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: '#005eb8' }} />}
        sx={{
          minHeight: 58,
          flexDirection: 'row-reverse',
          gap: 1.5,
          color: '#004c97',
          backgroundColor: '#e9f5fd',
          '&.Mui-expanded': { minHeight: 58 },
          '& .MuiAccordionSummary-content': { margin: '8px 0' }
        }}>
        <div>
          <Typography fontWeight={700}>
            Point of Contacts: Renewal Questionnaire &amp; Masterdata Upload (Yearly Plan Design/Carrier Change Updates)
          </Typography>
          <Typography variant="caption" sx={{ display: 'block', lineHeight: 1.2 }}>
            Designate the people responsible for completing the renewal questionnaire and uploading Masterdata information, who will receive the yearly emails requesting changes. List at least two contacts<span style={{ color: '#d32f2f' }}>*</span>
          </Typography>
        </div>
      </AccordionSummary>
      <AccordionDetails sx={{ p: { xs: 2, md: 3 } }}>
        <Controller
          name="planYearChanges"
          control={control}
          defaultValue=""
          rules={{ required: 'Select Yes or No' }}
          render={({ field, fieldState }) => (
            <FormControl required error={!!fieldState.error} sx={{ mb: 2 }}>
              <Typography id="plan-year-changes-label" component="span" fontWeight={600} color="#004c97">
                Plan Year - Are there any changes?
              </Typography>
              <RadioGroup row {...field} aria-labelledby="plan-year-changes-label">
                <FormControlLabel value="Yes" control={<Radio size="small" sx={radioSx} />} label="Yes" />
                <FormControlLabel value="No" control={<Radio size="small" sx={radioSx} />} label="No" />
              </RadioGroup>
              <FormHelperText>{fieldState.error?.message}</FormHelperText>
            </FormControl>
          )}
        />
        {[1, 2].map((index) => (
          <Grid container spacing={3} alignItems="flex-start" key={index} sx={{ mb: 0.5 }}>
            <Grid item xs={12} md="auto" sx={{ pt: { md: '32px !important' }, minWidth: 28 }}>
              <Typography color="#004c97">{index}.</Typography>
            </Grid>
            <Grid item xs={12} md>
              <ContactField
                index={index}
                type="Name"
                label="Contact Name"
                rules={{ required: 'Contact Name is required' }}
              />
            </Grid>
            <Grid item xs={12} md>
              <ContactField
                index={index}
                type="Email"
                label="Contact Email"
                rules={{
                  required: 'Contact Email is required',
                  pattern: { value: emailPattern, message: 'Enter a valid email address' }
                }}
              />
            </Grid>
            <Grid item xs={12} md>
              <ContactField
                index={index}
                type="Phone"
                label="Contact Phone Number"
                rules={{
                  required: 'Contact Phone Number is required',
                  validate: validatePhone
                }}
              />
            </Grid>
          </Grid>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

export default YearlyPocSection;